import { Middleware } from '@nuxt/types'
import {
  sovReqToken,
  VNCookie,
  ClickWorkToken,
  ClickWorkCookie,
  EverflowToken,
  EverflowCookie,
  OrangeBuddiesCookie,
  OrangeBuddiesToken,
  EverflowClientCookie,
  EverflowClientToken,
  UTMCampaignToken,
  UTMCampaignCookie,
  UTMMediumToken,
  UTMMediumCookie,
  UTMSourceToken,
  UTMSourceCookie,
  SnapchatClickIdToken,
  SnapchatClickIdCookie,
  FacebookClickIdToken,
  FacebookClickIdCookie,
  CookieDuration,
  LandingPageUrlCookie,
  PromotionCodeCookie,
  FeatureTestCookie,
  EverflowClientOfferIDToken,
  EverflowClientAffiliateIDToken,
  EverflowClientAdditionalParametersCookie,
  McanismToken,
  McanismCookie,
  OTANoCampaignCookie,
  Media4MomentsToken,
  Media4MomentsCookie,
  AdtractionToken,
  AdtractionCookie,
  ManualABTestingCookie,
  ManualABTestingCookieTwo,
  ManualABTestingCookieThree,
  SpaazaReferralCodeToken,
  SpaazaReferralCodeCookie
} from '@/enums/gtm'
import { getCookieDomain } from '@/utils/cookie'
import { PaymentFeatureFlagCookieQuery } from '@/enums/payments'
import { compareFbclid, formatFbclid } from '@/utils/tracking'
import { serializeParameters } from '@/utils/general'
import { getRandomVariant } from '@/utils/gtm'

const gtmMiddleware: Middleware = ({ route, app }) => {
  const sovendusToken = route.query[sovReqToken]
  const vnToken = route.query[VNCookie]
  const cbToken = route.query[ClickWorkToken]
  const efToken = route.query[EverflowToken]
  const obToken = route.query[OrangeBuddiesToken]
  const efcToken = route.query[EverflowClientToken]
  const fbClickId = route.query[FacebookClickIdToken]
  const utmSource = route.query[UTMSourceToken]
  const utmMedium = route.query[UTMMediumToken]
  const utmCampaign = route.query[UTMCampaignToken]
  const promotionCode = route.query.code
  const noCampaign = route.query.nocam
  const featureTest = route.query[FeatureTestCookie]
  const mcanismClickId = route.query[McanismToken]
  const media4Moments = route.query[Media4MomentsToken]
  const adtraction = route.query[AdtractionToken]
  const spaazaReferralCode = route.query[SpaazaReferralCodeToken]
  const hasPaymentFeatureFlagQuery = route.query.hasOwnProperty(PaymentFeatureFlagCookieQuery)

  const variant = getRandomVariant(4)

  if (app.$cookies.get(ManualABTestingCookie) === undefined) {
    app.$cookies.set(ManualABTestingCookie, variant, { expires: new Date(Date.now() + CookieDuration), path: '/', domain: getCookieDomain() })
  }

  const variantTwo = getRandomVariant(4)

  if (app.$cookies.get(ManualABTestingCookieTwo) === undefined) {
    app.$cookies.set(ManualABTestingCookieTwo, variantTwo, { expires: new Date(Date.now() + CookieDuration), path: '/', domain: getCookieDomain() })
  }

  const variantThree = getRandomVariant(20)

  if (app.$cookies.get(ManualABTestingCookieThree) === undefined) {
    app.$cookies.set(ManualABTestingCookieThree, variantThree, { expires: new Date(Date.now() + CookieDuration), path: '/', domain: getCookieDomain() })
  }

  if (hasPaymentFeatureFlagQuery) {
    app.$cookies.set(PaymentFeatureFlagCookieQuery, 'true', { expires: new Date(Date.now() + CookieDuration), path: '/', domain: getCookieDomain() })
  }

  if (sovendusToken) {
    app.$cookies.set(sovReqToken, sovendusToken, { expires: new Date(Date.now() + CookieDuration), path: '/', domain: getCookieDomain() })
  }

  if (vnToken) {
    app.$cookies.set(VNCookie, vnToken, { expires: new Date(Date.now() + CookieDuration), path: '/', domain: getCookieDomain() })
  }

  if (spaazaReferralCode) {
    app.$cookies.set(SpaazaReferralCodeCookie, spaazaReferralCode, { expires: new Date(Date.now() + CookieDuration), path: '/', domain: getCookieDomain() })
  }

  if (cbToken) {
    app.$cookies.set(ClickWorkCookie, cbToken, { expires: new Date(Date.now() + CookieDuration), path: '/', domain: getCookieDomain() })
  }

  if (efToken) {
    app.$cookies.set(EverflowCookie, efToken, { expires: new Date(Date.now() + CookieDuration), path: '/', domain: getCookieDomain() })
  }

  if (obToken) {
    app.$cookies.set(OrangeBuddiesCookie, obToken, { expires: new Date(Date.now() + CookieDuration), path: '/', domain: getCookieDomain() })
  }

  if (efcToken) {
    app.$cookies.set(EverflowClientCookie, efcToken, { expires: new Date(Date.now() + CookieDuration), path: '/', domain: getCookieDomain() })
  }

  if (featureTest) {
    app.$cookies.set(FeatureTestCookie, featureTest, { expires: new Date(Date.now() + CookieDuration), path: '/', domain: getCookieDomain() })
  }

  if (fbClickId) {
    const oldFbclid = app.$cookies.get(FacebookClickIdCookie)

    if (!oldFbclid || !compareFbclid(fbClickId, oldFbclid)) {
      const newFbclid = formatFbclid(`${fbClickId}`)
      app.$cookies.set(FacebookClickIdCookie, newFbclid, { expires: new Date(Date.now() + CookieDuration), path: '/', domain: getCookieDomain() })
    }
  }

  if (route.query[SnapchatClickIdToken]) {
    app.$cookies.set(SnapchatClickIdCookie, route.query[SnapchatClickIdToken], { expires: new Date(Date.now() + CookieDuration), path: '/', domain: getCookieDomain() })
  }

  if (utmSource) {
    app.$cookies.set(UTMSourceCookie, utmSource, { path: '/', domain: getCookieDomain() })
  }

  if (utmMedium) {
    app.$cookies.set(UTMMediumCookie, utmMedium, { path: '/', domain: getCookieDomain() })
  }

  if (mcanismClickId) {
    app.$cookies.set(McanismCookie, mcanismClickId, { expires: new Date(Date.now() + 86400000), path: '/', domain: getCookieDomain() })
  }

  if (media4Moments) {
    app.$cookies.set(Media4MomentsCookie, media4Moments, { expires: new Date(Date.now() + 86400000), path: '/', domain: getCookieDomain() })
  }

  if (adtraction) {
    app.$cookies.set(AdtractionCookie, adtraction, { expires: new Date(Date.now() + 86400000), path: '/', domain: getCookieDomain() })
  }

  if (noCampaign) {
    app.$cookies.set(OTANoCampaignCookie, noCampaign, { path: '/', domain: getCookieDomain() })
  }

  if (utmCampaign) {
    app.$cookies.set(UTMCampaignCookie, utmCampaign, { path: '/', domain: getCookieDomain() })
  }

  if (route.fullPath && process.server && !route.fullPath.includes('signup/create-account/verification-payment/')) {
    app.$cookies.set(LandingPageUrlCookie, route.fullPath, { expires: new Date(Date.now() + CookieDuration), path: '/', domain: getCookieDomain() })
  }

  if (promotionCode) {
    app.$cookies.set(PromotionCodeCookie, promotionCode, { expires: new Date(Date.now() + CookieDuration), path: '/', domain: getCookieDomain() })
  }

  const everflowAdditionalParams = {
    adv_event_id: route.query.adv_event_id,
    oid: route.query[EverflowClientOfferIDToken],
    affid: route.query[EverflowClientAffiliateIDToken],
    source_id: route.query.source_id,
    sub1: route.query.sub1,
    sub2: route.query.sub2,
    sub3: route.query.sub3,
    sub4: route.query.sub4,
    sub5: route.query.sub5
  }

  const additionalParams = serializeParameters(everflowAdditionalParams)
  const hasAtLeastOneValue = Object.values(everflowAdditionalParams).some(value => value !== undefined && value !== null && value !== '')

  if (additionalParams && hasAtLeastOneValue) {
    app.$cookies.set(EverflowClientAdditionalParametersCookie, additionalParams, { expires: new Date(Date.now() + CookieDuration), path: '/', domain: getCookieDomain() })
  }
}

export default gtmMiddleware
